import { render, staticRenderFns } from "./ClickerCube.vue?vue&type=template&id=d25e63ca&"
import script from "./ClickerCube.vue?vue&type=script&lang=js&"
export * from "./ClickerCube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports